<template>
  <div>
    <!-- 进入直播 header -->
    <van-nav-bar v-if="type == 'live' && showPlayback" :hasRightContent="true" :fixed="true" z-index="10" left-arrow :title="chapter_title" @click-left="liveLeftHandler" @click-right="rightHandler">
      <template #right>
        <van-icon name="wap-nav" size="24" />
      </template>
    </van-nav-bar>
    <!-- 主header -->
    <Header v-else :hasRightContent="true" :navTitle="chapter_title" :navPath="`/mobile/course/detail/${ cur_uuid }`" :rightHandler="rightHandler">
      <template #navRightContent v-if="chapter.course_num > 1">
        <van-icon name="wap-nav" size="24" />
      </template>
    </Header>
    <!-- 视频区 -->
    <div class="top_content">
      <!-- 认证 -->
      <div class="info_center" v-if="type == 'authentication'">
        <h2>{{ chapter_title }}</h2>
        <p>{{ course.platform }}</p>
        <p>{{ course.description }}</p>
        <p>授权码：{{ course.assign_state }}</p>
        <p>到期日期：<span v-if="course.assign_state == '发放中'">-</span><span v-else>{{ course.code_expired_at}}</span></p>
      </div>
      <!-- 面授 -->
      <div class="info_center" v-if="type == 'face_teaching'">
        <h2>{{ chapter_title }}</h2>
        <p>{{ course.description }}</p>
        <p><i class="el-icon-timer"></i> {{ course.start_at }}</p>
        <p><i class="el-icon-map-location"></i> {{ course.position_str }}</p>
      </div>
      <!-- 视频 -->
      <div class="video_wrap" v-if="type == 'video'" ref="videoWrap">
        <div class="video">
           <video-play v-if="canStudy" :canStudy="canStudy" :video="course" :record="true" :cur_uuid="cur_uuid" ref="video"></video-play>
        </div>
        <div class="container">
          <h1>{{ chapter_title }}</h1>
          <p>{{ course.description }}</p>
        </div>
      </div>
      <!-- 直播 -->
      <div class="info_center" v-if="type == 'live' && !showPlayback">
        <h2>{{ chapter_title }}</h2>
        <p>{{ course.description }}</p>
        <p><i class="el-icon-timer"></i>{{showTime(course.start_at, course.end_at)}}</p>
        <div v-if="getLiveStatus(course.end_at) == 1">
          <p class="text-center"><van-button type="primary" @click="enterLive">进入直播</van-button></p>
        </div>
        <div v-else-if="backplayNum > 0">
          <p class="text-center"><van-button type="primary" @click="showPlayback = true">直播回放</van-button></p>
        </div>
        <div v-else-if="backplayNum == 0">
          <p class="text-center"><span class="waiting">回放视频处理中</span></p>
        </div>
      </div>
      <!-- 进入直播 -->
      <div class="video_wrap" v-if="type == 'live' && showPlayback">
        <div class="video">
           <video-play v-if="canStudy" :canStudy="canStudy" :video="live.playback_video" :record="false" :cur_uuid="cur_uuid" ref="live"></video-play>
        </div>
        <div class="container">
          <h1>{{ live.playback_name }}</h1>
          <p>{{ live.playback_description }}</p>
        </div>
      </div>
    </div>
    <div style="background:#f8f8f8;height:15px;"></div>
    <div v-if="courseWareList.length > 0 || course.question_num > 0">
      <van-tabs
        ref="courseDetailTabs"
        v-model:active="activeName"
        color="#009dd9"
        title-active-color="#00ADEF"
        line-width="50"
        class="tab_common">
        <van-tab title="课件" name="courseware" v-if="courseWareList.length > 0">
          <TeachingCourseware :courseware_list="courseWareList"></TeachingCourseware>
        </van-tab>
        <van-tab title="练习题" name="question" v-if="course.question_num > 0">
            <TeachingExercise :paper_ids="course.paper_ids" :cur_name="cur_name"></TeachingExercise>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 视频回放列表 -->
    <TopSlideSheet v-model:isShow="chapter.visible">
      <template #content>
        <div class="chapter_wrap">
          <div class="chapter">
            <ul class="menu_list_common" v-if="type == 'live' && showPlayback">
              <li v-for="item in live.options" :key="item.value" :class="{'active': live.value === item.value}" @click="playbackVideoSelectChanged(item.value)">{{ item.label }}</li>
            </ul>
            <dl v-else>
              <div v-for="(chapter_item, chapter_index) in chapter.list">
                <dt>{{ chapter_item.title }}</dt>
                <dd @click="changeChapter(item)" :class="{'active': item.video_uuid == uuid || item.live_uuid == uuid || item.face_uuid == uuid || item.authentication_uuid == uuid}" v-for="(item, index) in chapter_item.chapter_content">
                  <div class="left">
                    <i :class="{'iconfont': true, 'icon-qqq-02': item.live_uuid, 'icon-qqq_huaban1': item.face_uuid,
                      'icon-qqq-03': item.video_uuid, 'icon-tubiaocankaoxian1024-05': item.authentication_uuid, 'icon-tubiaocankaoxian1024-04-copy-copy': item.experiment_uuid}"></i>
                    <span class="title text_ellipsis">{{item.name}}</span>
                  </div>
                  <div class="right">
                    <span>{{ item.state }}</span>
                  </div>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </template>
    </TopSlideSheet>
  </div>
</template>

<script>
import Header from 'components/mobile/common/Header'
import TeachingCourseware from 'views_mf/course/includes/TeachingCourseware'
import TeachingExercise from 'views_mf/course/includes/TeachingExercise'
import TopSlideSheet from "components/mobile/common/TopSlideSheet"
import { showMessage, showNotify } from 'api/base/mobile/message'
import { scrollToTop } from "utils/mobile/common"
import { init, getCurRecord, checkLogin, getCurChapter } from "api/course/course/study"
import { listVideo } from "api/course/video/list"
import VideoPlay from "components/course/VideoPlay"
import { checkUserStudy } from "api/course/course/study"

export default {
  components: {
    Header,
    TeachingCourseware,
    TeachingExercise,
    VideoPlay,
    TopSlideSheet
  },
  data() {
    return {
      backplayNum: -1,
      type: '',
      cur_uuid: '',
      cur_name: '',
      uuid: '',
      chapter_title: '',
      layerShow: false,
      courseWareList: [],
      course: {
        platform: '',
        description: '',
        assign_state: '',
        code_expired_at: '',
        start_at:'',
        position_str:'',
        //end_at:'',
        question_num:'',
        paper_ids:''
      },
      canStudy: false,
      dragParams: {
        isDrag: false,
        initDisX: 400,
        disX: 400,
        lineWidth: 12,
      },
      activeName: 'courseware',
      chapter: {
        visible: false,
        list: [],
        course_num: 0,
      },
      live: {
        value: '0',
        playback_video: '',
        playback_description: '',
        options: []
      },
      showPlayback: false,
    }
  },
  mounted() {
    this.$emit('update:isShowHeader', false);
    this.$nextTick(()=>{
       scrollToTop()
    })
    this.type = this.$route.params.type
    this.cur_uuid = this.$route.params.cur_uuid
    this.uuid = this.$route.params.uuid
    this.initPage()
  },
  methods: {
    changeChapter(item) {
      console.log(item);
      if(item.type === 'experiment') {
        console.log(111);
        showNotify('实验类课程请在PC端学习', 'warning')
        return
      }

      this.goPath(`/mobile/course/detail/${item.type}/${this.cur_uuid}/${item.uuid}`)
      this.chapter.visible = false
      scrollToTop()
    },
    rightHandler() {
      const videos = document.getElementsByTagName('video')
      if(this.chapter.visible === false) {
        for(let video of videos) {
          video.style.display = 'none'
        }
      }
      this.chapter.visible = !this.chapter.visible
      if(this.chapter.visible === false) {
        for(let video of videos) {
          video.style.display = 'block'
        }
      }
    },
    liveLeftHandler() {
      this.showPlayback = false
    },
    initPage(){
      setInterval(checkLogin, 600000)
      const that = this
      if(this.uuid == undefined || this.uuid == '' || this.uuid == 'undefined'){
        return false;
      }
      let params = {'type': this.type, 'uuid': this.uuid, 'cur_uuid': this.cur_uuid}
      init(params).then(res => {
        if(res.code === 0){
          let data = res.data
          that.cur_name = res.cur_name
          that.course = data

          if(res.courseware_list.length > 0){
            that.activeName = 'courseware'
          }
          else {
            that.activeName = 'question'
          }
          that.courseWareList = res.courseware_list
          if(that.type == 'authentication') {
            if(data.code) {
              that.course.code_expired_at = data.code.expired_at;
            }
          }
          if(that.type == 'live'){
            let playback_videos = data.playback_videos
            if (playback_videos.length > 0){
              let video_id = playback_videos[0].id
              that.live.value = video_id
              that.backplayNum = playback_videos.length
              listVideo({'video_id': video_id})
                .then(v => {
                  if(v.total > 0){
                    that.live.playback_video = v.data[0]
                    that.live.playback_description = v.data[0].description
                    that.live.playback_name = v.data[0].name
                  }
                  else {
                    showMessage('获取视频失败')
                  }
                })
            }else{
              that.backplayNum = 0
            }
            that.live.options = []
            playback_videos.forEach(v => {
              that.live.options.push({
                'value': v.id,
                'label': v.name
              })
            })
          }
          that.canStudy = true
          that.setChapterState()
        }
        else if(res.code == 1){
          this.goPath('/mobile/course/detail/' + this.cur_uuid)
        }
        else if(res.code == 2){
          this.goPath('/login?target=' + location.pathname)
        }
        else {
          showMessage(res.error).then(()=>{
            that.goPath('/mobile/course/detail/' + that.cur_uuid)
          })
          // that.$alert(res.error, '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //     that.goPath('/course/detail/' + that.cur_uuid)
          //   }
          // });
        }
      })
    },
    getLiveStatus(end_at){
      if(end_at != undefined){
        let end = dayjs().diff(end_at)
        if(end < 0){
          return 1
        }
      }
    },
    enterLive(){
      window.open(this.course.join_url)
    },
    playbackVideoSelectChanged(video_id){
      this.live.value = video_id;
      this.chapter.visible = false;
      let that = this
      listVideo({'video_id': video_id})
            .then(v => {
              if(v.total > 0){
                that.$refs.live.destoryVideoPlayer()
                that.live.playback_video = v.data[0]
                that.live.playback_name = v.data[0].name
                that.live.playback_description = v.data[0].description
              }
              else {
                showMessage('获取视频失败')
              }
            })
    },
    showTime(start_at, end_at){
      let t = dayjs(end_at).unix() - dayjs(start_at).unix()
      let startDate = dayjs(start_at).format('YYYY-MM-DD')
      let endDate = dayjs(end_at).format('YYYY-MM-DD')
      if (t >= 24*60*60){
        return dayjs(start_at).format('YYYY-MM-DD HH:mm:ss') + '-' + dayjs(end_at).format('YYYY-MM-DD HH:mm:ss')
      }else if (startDate == endDate){
        return startDate + ' ' + dayjs(start_at).format('HH:mm:ss') + '-' + dayjs(end_at).format('HH:mm:ss')
      }

    },
    goBack() {
      this.$router.push(`/course/detail/${this.cur_uuid}`);
    },
    closeChapter() {
      this.chapter.visible = false;
    },
    goPath(path) {
      this.$router.push(path);
    },
    setChapterState() {
      let params = {'uuid': this.uuid, 'cur_uuid': this.cur_uuid}
      const that = this
      getCurChapter(params).then(res => {
        if(res.code == 0){
          that.chapter_title = res.chapter_title
          that.chapter.list = res.chapter

          //标签页title
          document.title = `${ that.chapter_title }-${ that.cur_name }-未来网络学堂`;

          //reload 7moor js
          const s = document.createElement('script');
          s.type = 'text/JavaScript';
          s.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=a4c3d330-5dcc-11ea-b7ff-07dd5ece4b95&autoShow=true&language=ZHCN';
          document.body.appendChild(s);

          let video_index = 0
          let now = new Date()
          for(let i=0; i<this.chapter.list.length; i++) {
            this.chapter.list[i].chapter_content.forEach(item => {
              this.chapter.course_num++;
              if (item.face_uuid) {
                item.start_at = dayjs(item.face_teaching.start_at).format('MM-DD HH:mm')
                item.end_at = dayjs(item.face_teaching.end_at).format('MM-DD HH:mm')
                let position = JSON.parse(item.face_teaching.position)
                if (position[0].label.indexOf('市') >= 0) {
                  item.city = position[0].label
                } else {
                  item.city = position[1].label
                }
                if (now < new Date(item.face_teaching.start_at)) {
                  item.state = '未开始'
                } else if (now < new Date(item.face_teaching.end_at)) {
                  item.state = '进行中'
                } else {
                  item.state = '已结束'
                }
              } else if (item.live_uuid) {
                item.start_at = dayjs(item.live.start_at).format('MM-DD HH:mm')
                item.end_at = dayjs(item.live.end_at).format('MM-DD HH:mm')
                if (now < new Date(item.live.start_at)) {
                  item.state = '未开始'
                } else if (now < new Date(item.live.end_at)) {
                  item.state = '进行中'
                } else {
                  item.state = '已结束'
                }
              } else if (item.video_uuid) {
                item.video_index = video_index++
              }
            })
          }
          this.getStudyState()
        }
      })
    },
    getStudyState() {
      let data = {
        cur_uuid: this.cur_uuid
      }
      const that = this
      getCurRecord(data).then(res => {
        if(res.code === 0){
          let video_obj = {}
          let codes = []
          for(let i=0; i<res.video_records.length; i++){
            let record = res.video_records[i]
            if(record.is_finish || !(record.video_uuid in video_obj)){
              video_obj[record.video_uuid] = record.is_finish
            }
          }
          for(let i=0; i<res.codes.length; i++){
            codes.push(res.codes[i].auth_uuid)
          }
          that.chapter.list.forEach(chapter => {
            chapter.chapter_content.forEach(item => {
              if(item.video_uuid){
                if (item['video_uuid'] in video_obj){
                  item.state = video_obj[item['video_uuid']] == 1 ? '已学习' : '学习中'
                }
                else {
                  item.state = '未学习'
                }
              }
              if(item.authentication_uuid){
                if(codes.indexOf(item.authentication_uuid) >= 0){
                  item.state = '已获取'
                }
                else {
                  item.state = '发放中'
                }
              }
              if(item.experiment_uuid){
                  if(item.state == 'running'){
                    item.state = '学习中'
                  }
                  else if (item.state == 'over'){
                    item.state = '已学习'
                  }
                  else if (item.state == ''){
                    item.state = '未学习'
                  }else if (item.state == 'null'){
                      item.state = '暂未发布'
                  }
              }
            })
          })
        }
      })
    },
  },
  watch: {
    $route (val, oldVal) {
      if(val.name === 'CourseTeaching'){
        this.closeChapter()
        this.canStudy = false
        this.type = val.params.type
        this.cur_uuid = val.params.cur_uuid
        this.uuid = val.params.uuid
        this.initPage()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.top_content {
  position: relative;
  z-index: 1;
}
.info_center {
  padding:20px 15px 15px 15px;
  background:#000;
  text-align:center;
  line-height: 1.5;
  h2 {
    color:#00adef;
    margin-top:0;
    margin-bottom:15px;
    font-size:16px;
  }
  p {
    color:#d7d7d8;
    margin-top:0;
    margin-bottom:15px;
    .waiting {
      display:inline-block;
      padding:10px 15px;
      color:#919194;
      border:1px solid #919194;
      border-radius:4px;
    }
  }
}
.video_wrap {
 .video {
   height: 56.25vw;
 }
 .container {
   h1 {
     margin-top:0;
     font-size:14px;
     color:#333;
     line-height:1.5;
     margin-bottom:10px;
   }
   p {
     font-size: 12px;
     color: #666;
     margin: 0;
     line-height:1.5;
     max-height: 50px;
     overflow-x: hidden;
     overflow-y: auto;
   }
 }
}
.chapter_wrap {
  position:relative;
  .chapter {
    dl {
      margin:0;
      dt {
        padding:10px;
        background:#f5f5f5;
        color:#333;
      }
      dd {
        margin:0;
        padding:10px 0;
        display:flex;
        font-size:12px;
        cursor: pointer;
        .left {
          flex:1;
          display: flex;
          align-items: center;
          overflow:hidden;
          > i {
            color:#9da6b7;
            font-size:18px;
            margin-right:10px;
          }
          > .title {
            flex:1;
            min-width: auto;
            padding-top: 4px;
            padding-bottom: 4px;
          }
        }
        .right {
          width:60px;
          color:#999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.active {
          .left {
            > i, > .title {
              color:#009dd9;
            }
          }
        }
        &.disabled {
          opacity:0.5;
        }
      }
    }
  }
}
</style>
